import React, { useState } from 'react'

import { Reservation as IReservation } from 'services/reservation'

import ModalGeneric from '../ModalGeneric'

import { Patient } from './types'

import { FindPatient } from './components/FindPatient'
import { ChooseReservation } from './components/ChooseReservation'
import { SuccessReservation } from './components/SuccessReservation'

import * as S from './styles'

export enum Steps {
  FIND_PATIENT = 'FIND_PATIENT',
  CHOOSE_RESERVATION = 'CHOOSE_RESERVATION',
  SUCCESS = 'SUCCESS',
}

export interface Reservation extends IReservation {
  hasRestrictions: boolean
}

interface CreateReservationProps {
  professionalUsername: string
  professionalUuid: string
  onCloseModal: (value: boolean) => void
}

export function CreateReservationModal({
  professionalUsername,
  professionalUuid,
  onCloseModal = () => null,
}: CreateReservationProps): JSX.Element {
  const [patient, setPatient] = useState<Patient>({} as Patient)
  const [step, setStep] = useState<Steps>(Steps.FIND_PATIENT)
  const [reservation, setReservation] = useState<Reservation>({} as Reservation)
  
  const choosePatient = (patient: Patient) => setPatient(patient)
  
  const changeStep = (step: Steps) => setStep(step)
  const createReservation = (reservation: Reservation) => setReservation(reservation)

  const hasPatient = Object.keys(patient).length > 0
  const hasReservation = Object.keys(reservation).length > 0
  const hasTitle = !hasReservation
  const hasSubTitle = hasTitle && hasPatient && step !== Steps.FIND_PATIENT

  function handleCloseModal() {
    onCloseModal(false)
  }

  const patientFirstName = hasPatient && patient.fullName.split(' ')[0]

  return (
    <ModalGeneric
      modalTitle={hasTitle && 'Reserva de horário'}
      modalSubtitle={hasSubTitle && <>Paciente <b>{patient.fullName}</b></>}
      onCloseModal={handleCloseModal}
    >
      <S.CreateReservationContainer>

        {step === Steps.FIND_PATIENT && (
          <FindPatient 
            onSelectPatient={choosePatient}
            onChangeStep={changeStep}
          />
        )}

        {step === Steps.CHOOSE_RESERVATION && (
          <ChooseReservation 
            patient={patient}
            professionalUsername={professionalUsername}
            professionalUuid={professionalUuid}
            onChangeStep={changeStep}
            onCreateReservation={createReservation}
          />
        )}

        {step === Steps.SUCCESS && (
          <SuccessReservation
            patientName={patientFirstName}
            reservation={reservation}
            onCloseModal={handleCloseModal}
            exceptions={reservation?.nonRecurrentReservations?.successful}
          />
        )}

      </S.CreateReservationContainer>
    </ModalGeneric>
  )
}